import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import DeferredBackgroundChecks from './DeferredBackgroundChecks';
import messages from '../../../locale/messages';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.deferredBackgroundChecks);

    const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    if (!isAdminAuthenticated) {
        return { redirect: '/login' };
    }

    return {
        title,
        component: (
            <AdminLayout>
                <DeferredBackgroundChecks />
            </AdminLayout>
        ),
    };
}

export default action;
